import config from "environment";
import { getRequest } from "./client";
import {
  GetWorkspaceEmployeesContract,
  GetLinkRecordsForEmployeeContract,
  GetEmployeeProfileContract,
  Employee,
} from "winslow-core";

const { baseApi } = config;

export async function apiGetEmployees(workspaceId: string): Promise<any[]> {
  const fetchURL = `${baseApi}/employees/workspace/${workspaceId}`;

  const result = await getRequest<any[]>(fetchURL, "API/apiGetEmployees");
  return result || [];
}

export async function apiGetAllEmployees(
  workspaceId: string
): Promise<Employee[]> {
  const fetchURL = `${baseApi}/employees/${workspaceId}/all`;
  const result = await getRequest<any[]>(fetchURL, "API/apiGetEmployees");
  return result || [];
}

export async function apiGetEmployeeProfile(
  employeeId: string
): Promise<GetEmployeeProfileContract["Reply"]["data"]> {
  const fetchURL = `${baseApi}/employees/${employeeId}`;
  return await getRequest(fetchURL, "API/apiGetEmployeeProfile");
}

export async function apiGetEmployeeLinkRecords(
  employeeId: string,
  collectionId: string
): Promise<GetLinkRecordsForEmployeeContract["Reply"]["data"]> {
  const fetchURL = `${baseApi}/employees/${employeeId}/persona/${collectionId}`;
  const result = await getRequest<
    GetLinkRecordsForEmployeeContract["Reply"]["data"]
  >(fetchURL, "API/apiGetEmployeeLinkRecords");
  return result || null;
}
